module.exports = __webpack_public_path__ + "img/trash-bin_1.5704a81a.png";